module.exports = __webpack_public_path__ + "d0289dc0a46fc5b15b3363ffa78cf6c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/certIcon.png
// module id = 1301
// module chunks = 61